import React, {useEffect, useState} from "react";
import {Modal} from "../../../../ui/Modal/Modal";
import {ModalContentProps} from "../ModalContent";
import {InputElement} from "../../../../ui/Input/Input";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {cleanAllErrors, cleanError, PatchSnils} from "../api/slice";
import {Caption2} from "../../../../components/Font";
import {ContentXsTop} from "../../../../components/ui/Content";
import {useTheme} from "styled-components";
import {ISnilsRequest} from "../../../../interface/Passport/Account/backend";

export const ChangeSocialNumber = ({onGoBack, isInfoModalOpen, onGoInfoModal}: ModalContentProps) => {

    const dispatch = useAppDispatch()
    const {socialNumber, error, isFetching} = useAppSelector(state => state.account)
    const Theme = useTheme()
    const [info, setInfo] = useState<ISnilsRequest>({
        snils: ''
    })
    useEffect(() => {
        setInfo({
            ...info,
            snils: socialNumber? socialNumber.value : ''
        })
    }, [socialNumber])

    const content = () => {
        return <>
            <Caption2 color={Theme.color.secondary}>
                Введите 11 цифр без дефисов и пробелов
            </Caption2>
            <ContentXsTop>
                <InputElement
                    format={'###-###-### ##'}
                    error={error['snils']}
                    mask={'_'}
                    value={info.snils}
                    onChange={(value) => {
                        if (error['snils']) {
                            dispatch(cleanError('snils'))
                        }
                        setInfo({...info, snils: value})
                    }}/>
            </ContentXsTop>
        </>
    }

    return <Modal
        isFetching={isFetching}
        title={'СНИЛС'}
        onSubmit={() => {
            dispatch(cleanError('snils'))
            dispatch(PatchSnils(info))
        }}
        disable={info.snils.length < 11}
        content={content}
        onClose={()=>{
            dispatch(cleanAllErrors())
            if(isInfoModalOpen){
                onGoInfoModal()
            }
            onGoBack()
        }}/>
}